<template>
  <div class="content">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="/reworkHome" class="el-Page1 font25" @click="hrefPage1">复工备案统计表</el-menu-item>
      <el-menu-item index="/returnPro" class="el-Page2 font25" @click="hrefPage2">人员健康档案</el-menu-item>
      <el-menu-item
        v-if="port!='4'"
        index="/apartPro"
        class="el-Page3 font25"
        @click="hrefPage3"
      >疫情防控日报</el-menu-item>
      <el-menu-item index="/temperaPro" class="el-Page4 font25" @click="hrefPage4">体温检测表</el-menu-item>
      <el-menu-item index="/disin" class="el-Page5 font25" @click="hrefPage5">现场消毒记录统计</el-menu-item>
    </el-menu>
    <div class="home-con">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import myHttp from "../../../untils/port.js"
import util from "../../../untils/util.js"
import base from '../../../untils/base'
export default {
  isCollapse: false,
  data() {
    return {
      activeIndex: '',
      id: '',
      port: ''
    }
  },
  mounted() {
    this.activeIndex = '/' + this.$route.path.split('/')[1]
    let port = util.session.get('roleId')
    this.port = port
    if (this.$route.params.id == '0' && port == '4') {
      this.id = util.session.get('groupId')
    } else {
      this.id = this.$route.params.id
    }
  },
  methods: {
    hrefPage1() {
      // this.$router.push({name:'reworkHome',params:{id:this.id}})
      this.$router.push('/reworkHome/' + this.$route.params.id)
    },
    hrefPage2() {
      let id = ''
      this.$router.push({
        name: 'returnPro',
        params: { id: this.$route.params.id }
      })
    },
    hrefPage3() {
      this.$router.push({
        name: 'apartPro',
        params: { id: this.$route.params.id }
      })
    },
    hrefPage4() {
      this.$router.push({
        name: 'temperaPro',
        params: { id: this.$route.params.id }
      })
    },
    hrefPage5() {
      this.$router.push({
        name: 'disin',
        params: { id: this.$route.params.id }
      })
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    methods1: function() {
      realconsole()
    }
  }
}
</script>

<style scoped>
/* @import '../../assets/css/homePage.css'; */

* {
  box-sizing: border-box;
}
.home-con {
  height: calc(100% - 80px);
}
.content {
  width: 100%;
  height: 100%;
  min-width: 1080px;
  overflow-y: scroll;
  overflow-x: auto;
  box-sizing: border-box;
}

.content::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

.content::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

.content::-webkit-scrollbar-track {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
}

.progress-item .txt >>> .el-progress-bar__outer,
.progress-item .txt >>> .el-progress-bar__inner {
  border-radius: 0;
}
.font25 {
  font-size: 18px;
}
</style>